import { default as MuiCardHeader } from '@material-ui/core/CardHeader';

const CardHeader = MuiCardHeader;

export default CardHeader;
